// 表头图标配置
let headData = {
  title: '区块列表',
  items: [
    /* 新增按钮 */
    {
      style: 'button',
      label: '查看更多',
      size: 'medium',
      type: 'text',
      clickEvent: (thisVue) => {
        thisVue.toBlock()
      }
    }
  ]
}

// 列表columns配置
let columnsData = [
  {
    label: '序号',
    type: 'index',
    align: 'center',
    show: true,
    width: 100
  },
  {
    label: '分片',
    prop: 'shardName',
    show: true,
    align: 'center',
    width: 100
  },
  {
    label: '区块高度',
    prop: 'height',
    show: true,
    enableSlot: true,
    align: 'center',
    width: 100
  },
  {
    label: '出块时间',
    prop: 'timestamp',
    show: true,
    enableSlot: true,
    width: 200
  },
  {
    label: '区块哈希',
    prop: 'hash',
    show: true,
    enableSlot: true,
    minWidth: 200
  }
]

// 分页配置项
let pageData = {
  size: 10, // 每页的数据量
  total: 0, // 数据总量
  layout: 'prev, pager, next, total, jumper, slot',
  currentPage: 1 // 当前页
}

let tableObjListBlock = {
  'columnsData': columnsData, // 表格列/操作列配置
  'headData': headData, // 表头图标配置
  'pageData': pageData // 分页数据
}

export default tableObjListBlock
